"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _useInterval = _interopRequireDefault(require("../hooks/useInterval"));

var animationDelay = 500;

var _default = function _default() {
  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      dots = _useState2[0],
      setDots = _useState2[1];

  var addDot = function addDot() {
    var newDots = dots + ".";

    if (newDots.length > 3) {
      newDots = '';
    }

    setDots(newDots);
  };

  (0, _useInterval.default)(addDot, animationDelay);
  return _react.default.createElement("span", {
    className: "loading-dots"
  }, dots);
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/LoadingDots.js
// module id = 293
// module chunks = 0